import React, { PropTypes } from 'react';
import styled from 'styled-components';
import Drawer from 'material-ui/Drawer';
import Avatar from 'material-ui/Avatar';
import { Card, CardHeader, CardMedia } from 'material-ui/Card';
import Divider from 'material-ui/Divider';
import CreateIcon from 'material-ui/svg-icons/av/library-add';
import EventIcon from 'material-ui/svg-icons/action/event';
import CampaignIcon from 'material-ui/svg-icons/action/announcement';
import EarlyBirdIcon from 'material-ui/svg-icons/action/flight-takeoff';
import MenuItem from 'material-ui/MenuItem';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import ArrowDropRight from 'material-ui/svg-icons/navigation-arrow-drop-right';
import CorporateIcon from 'material-ui/svg-icons/action/work';
import CollegeIcon from 'material-ui/svg-icons/action/account-balance';
import UserIcon from 'material-ui/svg-icons/social/group';
import LogoutIcon from 'material-ui/svg-icons/action/exit-to-app';
import CorporateLink from 'material-ui/svg-icons/content/link';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import AppBar from 'material-ui/AppBar';
import truncate from 'lodash/truncate';
import drawerBackground from '../../images/drawer-background.jpg';
import logo from '../../images/logo-red.svg';
import { theme } from '../../utils/getTheme';
import Link from '../../components/Link';
import { auth } from '../../utils/configureFirebase';
import { ToastContainer } from 'react-toastify';

const Menu = props => (
  <IconMenu
    {...props}
    iconButtonElement={
      <IconButton>
        <MoreVertIcon />
      </IconButton>
    }
    targetOrigin={{ horizontal: 'right', vertical: 'top' }}
    anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
  >
    <MenuItem
      primaryText="Logout"
      leftIcon={<LogoutIcon />}
      onTouchTap={() => {
        auth.signOut();
        localStorage.clear();
      }}
    />
  </IconMenu>
);

Menu.muiName = 'IconMenu';

const LogoIcon = styled.img`
  width: 36px;
  height: 36px;
  margin-top: 4px;
`;

const ContentWrapper = styled.div`
  position: relative;
  left: 256px;
  width: calc(100% - 256px);
  position: relative;
  z-index: 2;
  padding: 80px 16px;

  &::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: ${props => props.theme.backgroundColor};
    z-index: -1;
  }
`;

const Secure = ({ user, children }) => (
  <div>
    <Drawer docked>
      <Card zDepth={0}>
        <CardMedia
          overlay={
            <div>
              <Avatar
                src={user.photoURL}
                style={{
                  marginLeft: 16,
                }}
              />
              <CardHeader
                title={user.displayName}
                titleColor={theme.alternateTextColor}
                subtitle={truncate(user.email, { length: 32 })}
                subtitleColor={theme.alternateTextColor}
              />
            </div>
          }
          overlayContentStyle={{
            background:
              'linear-gradient(to top, rgba(0,0,0,0.4), rgba(0,0,0,0))',
          }}
        >
          <img src={drawerBackground} alt="" />
        </CardMedia>
      </Card>

      <Link to="/">
        <MenuItem leftIcon={<CreateIcon />}>Create Drive</MenuItem>
      </Link>

      <Link to="/all">
        <MenuItem leftIcon={<EventIcon />}>Saved Drives</MenuItem>
      </Link>

      <Link to="/event/campaign">
        <MenuItem leftIcon={<CampaignIcon />}>Event Campaign</MenuItem>
      </Link>

      <MenuItem
        primaryText="CampuScape"
        checked
        leftIcon={<EarlyBirdIcon />}
        rightIcon={<ArrowDropRight />}
        menuItems={[
          <Link to="/campuscape/corporate">
            <MenuItem primaryText="Corporate" leftIcon={<CorporateIcon />} />
          </Link>,
          <Link to="/campuscape/connectcorporate">
            <MenuItem
              primaryText="Corporate Connect"
              leftIcon={<CorporateLink />}
            />
          </Link>,
          <Link to="/campuscape/campus">
            <MenuItem primaryText="Campus" leftIcon={<CollegeIcon />} />
          </Link>,
          <Link to="/campuscape/college/student">
            <MenuItem primaryText="Students" leftIcon={<UserIcon />} />
          </Link>,
        ]}
      />

      <Divider />

      <MenuItem
        leftIcon={<LogoutIcon />}
        onTouchTap={() => {
          auth.signOut();
        }}
      >
        Logout
      </MenuItem>
    </Drawer>

    <AppBar
      title="Admin"
      iconElementLeft={<LogoIcon src={logo} alt="MyAnatomy" />}
      style={{
        position: 'fixed',
        top: 0,
        left: 256,
        width: 'calc(100% - 256px)',
      }}
      iconElementRight={<Menu />}
    />

    <ContentWrapper>{children}</ContentWrapper>
    <ToastContainer
      hideProgressBar
      newestOnTop={true}
      autoClose={5000}
    />
  </div>
);

Secure.propTypes = {
  user: PropTypes.shape({
    uid: PropTypes.string.isRequired,
    displayName: PropTypes.string.isRequired,
    photoURL: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
  }).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
};

export default Secure;



// WEBPACK FOOTER //
// ./src/views/Secure/Secure.js